import { lazy, Suspense, useState } from "react";
import { Drawer, FloatButton, Grid, Layout, Spin } from "antd";
import { ArrowUpOutlined } from "@ant-design/icons";
import { Route, Routes } from "react-router-dom";
import { AppHeader } from "./components/layout/Header.js";
import { AppFooter } from "./components/layout/Footer.js";
import { Sidebar } from "./components/layout/Sidebar.js";
import { Home } from "./features/home/Home.js";
import { TextureBrowser } from "./features/gallery/TextureBrowser.js";

const Admin = lazy(() => import("./features/admin/Admin.js").then((m) => ({ default: m.Admin })));

const { Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const HEADER_HEIGHT = 60;

function PageFallback() {
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: 64 }}>
      <Spin />
    </div>
  );
}

export function App() {
  const screens = useBreakpoint();
  const isMobile = !screens.lg;
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Layout style={{ minHeight: "100vh", background: "transparent" }}>
      <AppHeader onToggleSidebar={isMobile ? () => setDrawerOpen(true) : undefined} />
      <Layout style={{ background: "transparent" }} hasSider>
        {!isMobile && (
          <Sider
            width={252}
            style={{
              background: "transparent",
              position: "sticky",
              top: HEADER_HEIGHT,
              height: `calc(100vh - ${HEADER_HEIGHT}px)`,
              overflow: "hidden",
              borderRight: "1px solid var(--tn-border-faint)",
            }}
          >
            <Sidebar />
          </Sider>
        )}
        <Drawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          placement="left"
          styles={{
            body: { padding: 0, background: "var(--tn-chrome)" },
            header: { display: "none" },
            content: { background: "var(--tn-chrome)" },
          }}
          width={300}
        >
          <Sidebar />
        </Drawer>

        <Content
          style={{
            padding: isMobile ? "12px" : "20px",
            minWidth: 0,
          }}
        >
          <div
            className="tn-panel"
            style={{
              maxWidth: 1800,
              margin: "0 auto",
              width: "100%",
              padding: isMobile ? "20px" : "28px 36px 40px",
              minHeight: `calc(100vh - ${HEADER_HEIGHT}px - 48px)`,
            }}
          >
            <Suspense fallback={<PageFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route
                  path="/category/:category/:id/:subcategories?"
                  element={<TextureBrowser />}
                />
                <Route path="/textures/:textures/:id" element={<TextureBrowser />} />
                <Route path="/search" element={<TextureBrowser />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </Suspense>
          </div>
        </Content>
      </Layout>
      <AppFooter />
      <FloatButton.BackTop icon={<ArrowUpOutlined />} />
    </Layout>
  );
}
